export default __webpack_public_path__ + "static/media/compliance.ae1c582f.svg";